import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-relatorio-despesas',
  templateUrl: './relatorio-despesas.component.html',
  styleUrls: ['./relatorio-despesas.component.css']
})
export class RelatorioDespesasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}